<template>
    <div class="page">
        <div v-if="you" class="profile">
            <div class="user subtle-background flex flex-center">
                <div class="user-avatar" @click="clickInput">
                    <avatar :avatar="you.base64avatar"></avatar>
                    <input style="display: none" type="file" id="selfie" capture="user" accept="image/*" @input="handleUploadAvatar"/>
                </div>
                <div class="info">
                    <!-- <span><strong>Profiel wijzigen</strong></span> -->
                    <span style="text-align: center">Profiel aanpassen</span>
                    <input v-model="you.name" class="name-input" type="text" placeholder="Jouw naam" size="10" @input="_handleSaveName">
                </div>
            </div>
            <div class="statistics subtle-background flex-column-gap">
                <div class="line">
                    <p class="left">Spellen gespeeld</p>
                    <p class="right">{{ you.statistics.gamesPlayed || 0 }}</p>
                </div>
                <div class="line">
                    <p class="left">Rondes gewonnen</p>
                    <p class="right">{{ you.statistics.roundsWon || 0 }}</p>
                </div>
                <div class="line">
                    <p class="left">Aantal keer gepaald</p>
                    <p class="right">{{ you.statistics.impaled || 0 }}</p>
                </div>
                <div class="line">
                    <p class="left">Shotjes genomen</p>
                    <p class="right">{{ you.statistics.shotsTaken || 0 }}</p>
                </div>
                <div class="line">
                    <p class="left">Aantal keer JP 0</p>
                    <p class="right">{{ you.statistics.finishedWithZero || 0 }}</p>
                </div>
            </div>
        </div>

        <div class="settings">
            <interactive class="card-style" :class="{ 'show-more': you.settings.allowNotifications }">
                <div class="setting" @click="handleToggleAllowNotifications">
                    <div class="left">
                        <p>Notificaties</p>
                    </div>
                    <div class="right">
                        <svg class="checkbox-icon" :class="{ checked: you.settings.allowNotifications }" viewBox="0 0 512 512">
                            <rect class="rect" x="64" y="64" width="384" height="384" rx="48" ry="48" fill="none" stroke="currentColor" stroke-linejoin="round" stroke-width="32"/>
                            <path class="check" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M352 176L217.6 336 160 272"/>
                        </svg>
                    </div>
                </div>
                <jump-transition v-if="you.settings.allowNotifications" :appear="false">
                    <div class="more-options">
                        <div class="setting" @click.stop="handleToggleNotificationType('remoteAdded')">
                            <div class="left">
                                <p>Toegevoegd aan nieuwe pot</p>
                            </div>
                            <div class="right">
                                <svg class="checkbox-icon" :class="{ checked: you.settings.allowedNotificationTypes.remoteAdded }" viewBox="0 0 512 512">
                                    <rect class="rect" x="64" y="64" width="384" height="384" rx="48" ry="48" fill="none" stroke="currentColor" stroke-linejoin="round" stroke-width="32"/>
                                    <path class="check" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M352 176L217.6 336 160 272"/>
                                </svg>
                            </div>
                        </div>
                        <div class="setting" @click.stop="handleToggleNotificationType('takeShots')">
                            <div class="left">
                                <p>Shots nemen</p>
                            </div>
                            <div class="right">
                                <svg class="checkbox-icon" :class="{ checked: you.settings.allowedNotificationTypes.takeShots }" viewBox="0 0 512 512">
                                    <rect class="rect" x="64" y="64" width="384" height="384" rx="48" ry="48" fill="none" stroke="currentColor" stroke-linejoin="round" stroke-width="32"/>
                                    <path class="check" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M352 176L217.6 336 160 272"/>
                                </svg>
                            </div>
                        </div>
                        <div class="setting" @click.stop="handleToggleNotificationType('scoreChanged')">
                            <div class="left">
                                <p>Score tussenstand (coming soon 😏)</p>
                            </div>
                            <div class="right">
                                <svg class="checkbox-icon" :class="{ checked: you.settings.allowedNotificationTypes.scoreChanged }" viewBox="0 0 512 512">
                                    <rect class="rect" x="64" y="64" width="384" height="384" rx="48" ry="48" fill="none" stroke="currentColor" stroke-linejoin="round" stroke-width="32"/>
                                    <path class="check" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M352 176L217.6 336 160 272"/>
                                </svg>
                            </div>
                        </div>
                    </div>
                </jump-transition>
            </interactive>
        </div>

        <div v-if="you && you.id" class="remove-you">
            <jump-transition>
                <div v-if="iterationsTillRemoved < 4">
                    <span style="display: block; text-align: center; width: 100%; margin-bottom: 10px;">Nog {{ iterationsTillRemoved }} keer drukken</span>
                </div>
            </jump-transition>
            <custom-button v-parse-emojis @click="removeYou" variation="danger">Ontkoppelen van {{ you.name }}</custom-button>
        </div>
    </div>
</template>

<script>
import { uploadAvatar, httpRequest } from '@/utils.js';
import _ from 'lodash';

import Interactive from '@/components/Interactive.vue';
import JumpTransition from '@/components/transitions/JumpTransition.vue';
import CustomButton from '@/components/CustomButton.vue';
import Avatar from '@/components/Avatar.vue';

export default {
    name: 'settings',
    components: {
        Interactive,
        Avatar,
        JumpTransition,
        CustomButton,
    },
    data() {
        return {
            empty: {
                name: '',
                base64avatar: null,
                settings: {
                    allowNotifications: false,
                    allowedNotificationTypes: {
                        remoteAdded: false,
                        scoreChanged: false,
                        takeShots: false
                    }
                },
                statistics: {},
                subscription: null
            },
            you: null,
            savingSettings: false,
            notificationsDenied: false,
            iterationsTillRemoved: 4
        }
    },
    methods: {
        clickInput() {
            document.getElementById('selfie').click();
        },
        async handleUploadAvatar(event) {
            const file = event.target.files[0];

            const avatar = await uploadAvatar(this.you.id, file);
            if(!avatar) return
            
            this.you.base64avatar = avatar;
            const stringify = JSON.stringify(this.you);
            localStorage.setItem('you', stringify);
        },
        _handleSaveName: _.debounce(function() { this.handleSaveName() }, 500),
        async handleSaveName() {
            if (this.savingSettings) return;

            this.savingSettings = true;
            const result = await httpRequest('POST', `/users/${this.you.id}`, { name: this.you.name });
            this.savingSettings = false;
            if (!result) return;

            localStorage.setItem('you', JSON.stringify(this.you));
        },
        async handleToggleAllowNotifications() {
            if (this.savingSettings) return;

            const { settings } = JSON.parse(JSON.stringify(this.you));

            settings.allowNotifications = !this.you.settings.allowNotifications;

            if (settings.allowNotifications) {
                Object.keys(settings.allowedNotificationTypes).forEach(key => settings.allowedNotificationTypes[key] = true);

                const granted = await new Promise(resolve => {
                    this.$root.$emit('requestNotificationPermission', resolve);
                });
                if (!granted) return;
            }

            this.savingSettings = true;
            const result = await httpRequest('POST', `/users/${this.you.id}`, { settings });
            this.savingSettings = false;
            if (!result) return;

            this.you.settings = result.settings;
            localStorage.setItem('you', JSON.stringify(this.you));
        },
        async handleToggleNotificationType(type) {
            if (this.savingSettings) return;

            const { settings } = JSON.parse(JSON.stringify(this.you));

            settings.allowedNotificationTypes[type] = !this.you.settings.allowedNotificationTypes[type];

            this.savingSettings = true;
            const result = await httpRequest('POST', `/users/${this.you.id}`, { settings });
            this.savingSettings = false;
            if (!result) return;

            this.you.settings = { ...result.settings };
            localStorage.setItem('you', JSON.stringify(this.you));
        },
        setYou() {
            let you = localStorage.getItem('you');
            if (!you) return this.you = this.empty;

            you = JSON.parse(you);
            this.you = { settings: this.empty.settings, ...you };
        },
        async removeYou() {
            if (this.iterationsTillRemoved > 1) return this.iterationsTillRemoved--;

            const { success } = await httpRequest('POST', '/push/unsubscribe', { userId: this.you.id });
            if (!success) return;

            localStorage.removeItem('you');
            localStorage.removeItem('subscriptionInitialized');
            this.$router.push('/');
            window.location.reload(true);
        },
        setNotificationSettings() {
            if (this.you.subscription) return;
            this.you.settings = this.empty.settings;
        }
    },
    created() {
        this.setYou();
        this.setNotificationSettings();
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/variables.scss';

.page {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding-inline: 20px;
    margin-top: -80px;
    padding-top: 100px;
    padding-bottom: 20px;
    color: white;
    flex-grow: 1;

    overflow-x: hidden;
    overflow-y: auto;

    --padding: 18px;

    p {
        font-size: 18px;
        line-height: 20px;
    }

    .profile {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 12px;

        .subtle-background {
            background: #00000040;
            border-radius: 12px;
            padding: var(--padding);
        }

        .user {
            display: flex;
            gap: 18px;
            width: calc(100% - (var(--padding) * 2));

            .user-avatar {
                .avatar {
                    width: 120px;
                    height: 120px;
                    box-shadow: 0 8px 24px -8px #081808;
                    border-radius: 50%;
                }
            }
            .info {
                display: flex;
                flex-direction: column;
                justify-content: center;
                gap: 12px;
                flex-grow: 1;

                .name-input {
                    display: block;
                    font-size: 16px;
                    border-radius: 12px;
                    padding: 8px 16px;
                    width: calc(100% - 32px);
                    border: none;
                    background: #00000040;
                    color: white;
                    caret-color: white;
                }
            }
        }

        .statistics {
            width: calc(100% - (var(--padding) * 2));

            .line {
                display: flex;
                justify-content: space-between;
                color: white;

                p {
                    text-shadow: 0 0 4px #00000099;
                }

                .left {
                    font-size: 16px;
                }
                .right {
                    font-size: 20px;
                    font-weight: 700;
                }
            }
        }

    }

    .settings {
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: var(--padding);

        .card-style {
            display: flex;
            flex-direction: column;
            background: #00000040;
            padding: var(--padding);
            border-radius: 12px;

            .more-options {
                display: flex;
                flex-direction: column;
                gap: var(--padding);
                margin-top: var(--padding);

                p {
                    font-size: 14px;
                }
            }
        }

        .setting {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 12px;

            .left {
                flex-grow: 1;
                .avatar {
                    width: 44px;
                    height: 44px;
                }
            }

            .right {
                height: 100%;

                .checkbox-icon {
                    float: right;
                }
            }
        }
    }
}

.checkbox-icon {
    --size: 24px;
    width: var(--size);
    height: var(--size);
    color: #515551;

    &.checked .check {
        clip-path: polygon(0 0, 100% 0, 100% 100%, 0% 100%);
    }

    .check {
        scale: 1.8;
        color: $weed-green;
        transform: translate(18px, -10px) rotate(6deg);
        transform-origin: center;
        clip-path: polygon(0 0, 0 0, 0 100%, 0% 100%);
        transition: .2s ease-in-out;
    }
}

</style>